import { ReactNode, useEffect, useState } from 'react'

import { InformationAPI } from '@builddocs/data-management'
import ym from 'react-yandex-metrika'

import { InformationModal } from './InformationModal'

interface InformationProviderProps {
  children: ReactNode
}

const FetchingInterval =
  process.env.NODE_ENV === 'production' || process.env.NX_ENV === 'production'
    ? 60 * 1000
    : 15 * 1000

export function InformationProvider({ children }: InformationProviderProps) {
  const [modalContents, setModalContents] = useState<{
    title: string
    content: string
    id: string
  }>()

  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  useEffect(() => {
    const onInterval = () => {
      InformationAPI.get('/changelists/last-unread')
        .then(r => r.data)
        .then(contents => {
          setModalContents(contents)
          onOpen()
        })
    }

    onInterval()

    const timerId = setInterval(onInterval, FetchingInterval)

    return () => clearInterval(timerId)
  }, [])

  const handleClose = () => {
    ym('reachGoal', 'close-information-modal')
    InformationAPI.put(`/changelists/${modalContents?.id}/read`)
    onClose()
  }

  return (
    <>
      {children}
      {modalContents && (
        <InformationModal
          {...modalContents}
          open={isOpen}
          onCancel={handleClose}
        />
      )}
    </>
  )
}
